module.exports = __webpack_public_path__ + "img/dengji2.24fcfa59.png";